



import IMapProperty from './private/IMapProperty';


const MAPPINGS: Array<IMapProperty> = [
{
    'localName' : 'id',
    'externalName' : 'id',
    'defaultValue' : 0,
},
{
    'localName' : 'name',
    'externalName' : 'name',
    'defaultValue' : '',
},
];

export default MAPPINGS;

